// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"395":"semantic","826":"index"}[chunkId] + ".css";
};